import React, { useRef, useState } from "react";

const COLORS = ["#ff0000", "#008000", "#0000ff", "#ff9900", "#000000"];

export default function ThreeFieldColorEditor() {
  const descRef = useRef(null);
  const [lastFocused, setLastFocused] = useState(null);

  /* 1️⃣ helper that actually wraps the selection */
  const applyColorToSelection = (color) => {
    if (!lastFocused) return;

    const selection = window.getSelection();
    if (!selection || selection.rangeCount === 0) return;

    const range = selection.getRangeAt(0);
    if (range.collapsed) return; // nothing selected

    // ensure the range is inside the field that had focus
    if (!lastFocused.contains(range.commonAncestorContainer)) return;

    // Wrap selected nodes in a <span style="color:...">
    const span = document.createElement("span");
    span.style.color = color;
    range.surroundContents(span);

    // optional: keep the caret after the colored text
    selection.collapseToEnd();
  };

  /* 2️⃣ click handler for color tiles */
  const handleColorClick = (color, e) => {
    e.preventDefault();      // keep focus inside editor
    applyColorToSelection(color);
  };

  /* 3️⃣ common props for each editable div */
  const editableProps = {
    contentEditable: true,
    suppressContentEditableWarning: true,
    style: {
      border: "1px solid #ccc",
      borderRadius: 4,
      padding: 8,
      minHeight: 60,
      marginBottom: 16,
    },
  };

  return (
    <div style={{ maxWidth: 600, margin: "0 auto", fontFamily: "sans-serif" }}>
      <label>Description</label>
      <div
        {...editableProps}
        ref={descRef}
        onFocus={() =>{
          setLastFocused(descRef.current)
        }}
      />

      {/* Color picker */}
      <h4>Select Text Color:</h4>
      <div style={{ display: "flex", gap: 12 }}>
        {COLORS.map((c) => (
          <button
            key={c}
            onMouseDown={(e) => handleColorClick(c, e)} /* mousedown keeps focus */
            style={{
              width: 30,
              height: 30,
              background: c,
              border: "1px solid #888",
              borderRadius: 4,
              cursor: "pointer",
            }}
          />
        ))}
      </div>
    </div>
  );
}
